import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  Button,
  useColorModeValue,
} from '@chakra-ui/react';

import CriarLiveForm from './FormLive';

type CriarLiveProps = {
  isOpen: boolean;
  onClose: () => void;
  data?: { nome?: string } | null;
};

export default function CriarLive({ isOpen, onClose, data }: CriarLiveProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg" isCentered>
      <ModalOverlay />

      <ModalContent borderRadius="2xl">
        <ModalHeader color={useColorModeValue('black', 'white')}>
          {' '}
          Nova Live de Vendas{' '}
        </ModalHeader>

        <ModalCloseButton color={useColorModeValue('black', 'white')} />

        <ModalBody>
          <CriarLiveForm data={data} />
        </ModalBody>

        <ModalFooter gap="3">
          <Button onClick={onClose} variant="ghost">
            Cancelar
          </Button>

          <Button colorScheme="blue">Conectar</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
